
import React from 'react';
import { 
  Card, 
  CardContent 
} from '@/components/ui/card';
import { Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      quote: "DirectPress has allowed me to build a direct relationship with my readers and earn a living from my journalism without compromise.",
      author: "Alex Johnson",
      role: "Investigative Journalist"
    },
    {
      quote: "The freedom to write what matters, not just what sells, has revitalized my passion for journalism. Plus, I'm earning more than I did at my previous publication.",
      author: "Maria Rodriguez",
      role: "Political Correspondent"
    },
    {
      quote: "As an independent journalist covering niche topics, I never thought I could make it work financially. DirectPress proved me wrong.",
      author: "Jamal Washington",
      role: "Science & Tech Writer"
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-directpress-blue mb-4">What Journalists Say</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Hear from journalists who have transformed their careers through DirectPress.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="border-none shadow-md">
              <CardContent className="p-8">
                <Quote className="h-8 w-8 text-directpress-orange opacity-60 mb-4" />
                <p className="text-gray-700 mb-6 italic">"{testimonial.quote}"</p>
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-directpress-blue/10 rounded-full flex items-center justify-center mr-3">
                    <span className="text-directpress-blue font-semibold">
                      {testimonial.author.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-directpress-blue">{testimonial.author}</h4>
                    <p className="text-sm text-gray-500">{testimonial.role}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
